import React from "react";
// ANT DESIGN COMPONENTS
import { Select } from "antd";
// INTERFACE
import { SelectProtocolTypeInterface } from "../../../interfaces/Global.interface";

export default function SelectProtocolType({
	value,
	onChangeProtocolType,
	disabledInput,
}: SelectProtocolTypeInterface) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const { Option } = Select;
	const PROTOCOLS_TYPES = ["MCE", "MODBUS", "BEAGLE", "LN1", "DILIGENT", "BACNET", "RVU", "OPC", "LOBBYVISION", "CGA", "SEQUENT"];

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const onChange = (newValue: string) => {
		onChangeProtocolType(newValue);
	};

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<Select className='generalStyles__width100' size='small' onChange={onChange} value={value} disabled={disabledInput}>
			{PROTOCOLS_TYPES.map((item: string) => (
				<Option key={item} value={item}>
					{item}
				</Option>
			))}
		</Select>
	);
}
